import Cookie from 'js-cookie';

export default {
  /**
   * 设置项目
   * @param name
   * @param value
   */
  setItem(name, value) {
    try {
      const str = typeof value === 'string' ? value : JSON.stringify(value);
      localStorage.setItem(name, str);
      sessionStorage.setItem(name, str);
    } catch (e) {
      console.error(e);
    }
  },
  /**
   * 获取值
   * @param name
   */
  getItem(name) {
    const value = localStorage.getItem(name);
    try {
      if (value) {
        sessionStorage.setItem(name, value);
      } else {
        sessionStorage.removeItem(name);
      }
    } catch (e) {
      console.error(e);
    }
    return value;
  },
  /**
   * 获取json格式的值
   * @param name
   * @param defaultValue 默认值
   */
  getJSONItem(name, defaultValue) {
    const value = localStorage.getItem(name);
    try {
      if (value) {
        sessionStorage.setItem(name, value);
        try {
          return JSON.parse(value);
        } catch (e) {
          console.error(e);
          return defaultValue;
        }
      }
      sessionStorage.removeItem(name);
    } catch (e) {
      console.error(e);
    }
    return defaultValue;
  },
  /**
   * 移除值
   * @param name
   */
  removeItem(name) {
    if (!name) {
      return;
    }
    if (typeof name === 'string') {
      localStorage.removeItem(name);
      sessionStorage.removeItem(name);
    } else if (Array.isArray(name)) {
      name.forEach((o) => {
        localStorage.removeItem(o);
        sessionStorage.removeItem(o);
      });
    } else {
      console.error('不支持的key类型:', name);
    }
  },

  /**
   * 清空
   */
  clearAll() {
    localStorage.clear();
    sessionStorage.clear();
  },

  /**
   * 是否包含
   * @param key
   */
  hasItem(key: string) {
    return localStorage.getItem(key) !== undefined || sessionStorage.getItem(key) !== undefined;
  },

  /**
   * 给集合中追加值
   */
  appendList(key: string, name: string, value: any) {
    const item = JSON.parse(localStorage.getItem(key) || '{}');
    item[name] = value;
    localStorage.setItem(key, JSON.stringify(item));
  },

  /**
   * 获取集合列表
   * @param key
   * @param name
   */
  getListItem(key: string, name: string) {
    const item = JSON.parse(localStorage.getItem(key) || '{}');
    return item[name];
  },

  /**
   * 清空cookie
   */
  removeCookie(name) {
    if (!name) {
      return;
    }
    if (typeof name === 'string') {
      Cookie.remove(name);
    } else if (Array.isArray(name)) {
      name.forEach((o) => {
        Cookie.remove(o);
      });
    } else {
      console.error('不支持的key类型:', name);
    }
  },
};
